$(document).ready(function () {
  console.log("load the page");

  //========Search[Header]
  new Typed(".typed_desk", {
    strings: ["Search Here…", "Search Here…"],
    typeSpeed: 120,
    delaySpeed: 120,
    loop: true,
  });

  new Typed(".header__content-mobile .typed_desk", {
    strings: ["Search Here…", "Search Here…"],
    typeSpeed: 120,
    delaySpeed: 120,
    loop: true,
  });

  //========Product Slider
  $(".product_slider_inner").slick({
    dots: true,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
        },
      },
    ],
  });

  //============Tabify
  $(".featured_collection li").click(function () {
    var tab_id = $(this).attr("data-tab");
    $(".featured_collection li").removeClass("hover_active");
    $(this).addClass("hover_active");
    $(this)
      .parents(".product_tabify")
      .find(".product_tab_details")
      .removeClass("active")
      .fadeOut("fast");
    $("#" + tab_id)
      .fadeIn(1000)
      .addClass("active");
  });

  var dropdownItems = document.querySelectorAll(
    ".variant-dropdown .dropdown-menu .dropdown-item"
  );
  var dorpdownTitle = document.querySelector(
    ".dropdown-toggle .variant-dropdown-value"
  );
  var dorpdownImage = document.querySelector(
    ".dropdown-toggle .drop_variant_color .variant-color-value"
  );

  dropdownItems.forEach(function (item) {
    item.addEventListener("click", function () {
      console.log("click");
      dropdownItems.forEach(function (item) {
        item.classList.remove("active");
      });
      this.classList.add("active");
    });
  });

  // from swatch to dropdown
  const colorSwatches = document.querySelectorAll(".product__color-swatch");

  // Find initially selected color
  let selectedColor;
  colorSwatches.forEach(function (swatch) {
    if (swatch.classList.contains("selected")) {
      selectedColor = swatch.getAttribute("data-option-value");
    }
    swatch.addEventListener("click", () => {
      selectedColor = swatch.getAttribute("data-option-value");
      if (selectedColor) {
        syncDropdown(selectedColor);
      }
    });
  });

  // Sync dropdown with initially selected color
  if (selectedColor) {
    console.log(selectedColor, "==>selectedColor");
    syncDropdown(selectedColor);
  }

  // Function to synchronize dropdown with selected color
  function syncDropdown(selectedColor) {
    dropdownItems.forEach(function (item) {
      const dropdownValue = item.getAttribute("data-val");
      if (dropdownValue === selectedColor) {
        // Add 'active' class to the dropdown item
        item.classList.add("active");
        dorpdownTitle.textContent = dropdownValue;
        let imageStyle = item
          .querySelector(".variant_color_name")
          .getAttribute("style");
        dorpdownImage.setAttribute("style", imageStyle);
      } else {
        // Remove 'active' class from other dropdown items
        item.classList.remove("active");
      }
    });
  }

  $(".variant-dropdown .dropdown-menu .dropdown-item").click(function () {
    var selectedValue = $(this).data("val");
    console.log("CLICK==>", selectedValue);
    var variantColorNameStyle = $(this)
      .find(".variant_color_name")
      .attr("style");

    $(".variant-dropdown .dropdown-toggle .variant-dropdown-value").text(
      selectedValue
    );
    $(".variant-dropdown .dropdown-toggle .variant-color-value").attr(
      "style",
      variantColorNameStyle
    );

    $(".product__color-swatches")
      .find('button[data-option-value="' + selectedValue + '"]')
      .trigger("click");
  });

  // TOP COLLECTION SEC SLIDER

  // Function to initialize Slick slider
  function initSlickSlider() {
    $(
      ".sub_categoriers_wrapper, .home_categoriers_wrapper, .custom_col_wrapper"
    ).slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: "unslick",
        },
      ],
    });
  }

  initSlickSlider();
  $(window).on("resize", function () {
    initSlickSlider();
  });
  $(window).on("load", function () {
    initSlickSlider();
  });

  //============Logo Slider
});
$(".featured_slider").slick({
  dots: false,
  infinite: true,
  arrows: false,
  speed: 300,
  slidesToShow: 7,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1441,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
});

document.addEventListener('DOMContentLoaded', function() {
document.getElementById('btm_menu_drawer').addEventListener('click', function() {
    // Find the button with the blank data-menu-button attribute
    const buttonToClick = document.querySelector('button[data-menu-button=""]');

    // If the button is found, trigger a click on it
    if (buttonToClick) {
        buttonToClick.click();
    } else {
        console.log('Button not found');
    }
});

});